import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import {
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  BtnIcon
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class ExpenseTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      search: "",
      count: 0,

      data: [],

      expense_type_id: "",
      expense_type_name: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let body = {
      page: page,
      data_search: this.state.search,
    };
    let result = await GET("api/admin/expense-types-centers/list", body);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count, page: page || 1 });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    if (!this.state.expense_type_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุชื่อค่าใช้จ่าย");
      return;
    }
    loading(true);
    let id = this.state.expense_type_id;
    let body = {
      expense_type_name: this.state.expense_type_name,
    };
    let result = !id
      ? await POST("api/admin/expense-types-centers/create", body)
      : await PUT("api/admin/expense-types-centers/update/" + id, body);
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("api/admin/expense-types-centers/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="ค่าใช้จ่ายกลาง"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">ประเภทค่าใช้จ่ายกลาง</h4>
          <div className="d-flex align-items-center flex-wrap">
            <input
              type="text"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="ชื่อค่าใช้จ่าย..."
              onChange={(e) => {
                this.setState({ search: e.target.value });
              }}
              value={this.state.search}
            />
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
            <button
              className="btn btn-success px-4 ms-auto mb-2"
              onClick={async () => {
                this.setState({
                  modal_create: true,
                  expense_type_id: "",
                  expense_type_name: "",
                });
              }}
            >
              เพิ่มประเภทค่าใช้จ่ายกลาง
            </button>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="wpx-50 text-center">ลำดับ</th>
                    <th>ชื่อค่าใช้จ่าย</th>
                    <th className="text-center wpx-90">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td className="text-center">{((this.state.page || 1) - 1) * 10 + index + 1}</td>
                      <td>{item.expense_type_name || ""}</td>
                      <td className="py-1">
                        <div className="d-flex justify-content-center">
                          {/* Update */}
                           <BtnIcon
                            type="update"
                            onClick={() => {
                              this.setState({
                                modal_update: true,
                                expense_type_id: item.expense_type_id,
                                expense_type_name: item.expense_type_name,
                              });
                            }}
                          />
                          {/* Delete */}
                           <BtnIcon
                            type="delete"
                            onClick={() => {
                              this.Delete(item.expense_type_id);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {this.state.count} รายการ</small>
            <Pagination
              count={Math.ceil(this.state.count / 10)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={this.state.modal_create || this.state.modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">
              {this.state.modal_create
                ? "เพิ่ม"
                : this.state.modal_update
                ? "แก้ไข"
                : ""}
              ประเภทค่าใช้จ่าย
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex mb-2">
              <div className="wpx-120 mt-2">ชื่อค่าใช้จ่าย</div>
              <input
                type="text"
                className="form-control"
                placeholder="กรอกข้อมูล..."
                onChange={(e) => {
                  this.setState({ expense_type_name: e.target.value });
                }}
                value={this.state.expense_type_name}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-end">
              <button className="btn btn-success px-4 me-1" onClick={() => { this.CreateUpdate(); }}>
                บันทึก
              </button>
              <button className="btn btn-danger px-4 ms-1" onClick={() => { this.setState({ modal_create: false, modal_update: false }); }}>
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
